/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../../api/index';
import * as core from '../../core';
import * as serializers from '../index';
import { DidCommMessageBlobStatus } from './DidCommMessageBlobStatus';

export const DidCommMessageCreateBlobsStatus: core.serialization.ObjectSchema<
    serializers.DidCommMessageCreateBlobsStatus.Raw,
    Truvity.DidCommMessageCreateBlobsStatus
> = core.serialization.object({
    messages: core.serialization.list(DidCommMessageBlobStatus),
});

export declare namespace DidCommMessageCreateBlobsStatus {
    export interface Raw {
        messages: DidCommMessageBlobStatus.Raw[];
    }
}
